import { useReducedMotion } from 'framer-motion';
import { memo } from 'react';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';
import Video from '@/app/components/Video/Video';

const StaticHero = () => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <Motion
      className="relative z-10 h-full md:motion-safe:hidden"
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ duration: 1.5, type: 'tween' }}
    >
      <div className="absolute top-0 left-1/2 aspect-square w-[70vh] -translate-x-1/2 lg:hidden">
        <Image
          className="object-cover"
          fill
          localizedAlt="jade_assortment_image_alt"
          src="/home-hero/or4-ceramic-home-hero-mobile.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.45&fp-z=1.5"
          priority
        />
        <div className="absolute size-full bg-linear-to-t from-[#CCD1D8] to-transparent to-40%" />
      </div>
      {shouldReduceMotion ? (
        <Image
          className="object-cover max-lg:hidden"
          fill
          localizedAlt="jade_assortment_image_alt"
          src="/home-hero/or4-ceramic-home-hero-desktop.png?ar=6:5&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.42&fp-z=1&rot=300"
        />
      ) : null}
    </Motion>
  );
};

const VideoHero = memo(function VideoHero() {
  const shouldReduceMotion = useReducedMotion();

  if (!shouldReduceMotion) {
    return (
      <Video
        className="relative hidden size-full object-cover object-[50%_30%] md:block"
        autoPlay
        contentTitle="home_hero"
        location="home_hero"
        type="video/mp4"
        muted
        playVideo
        preload="auto"
        priority
        controls={false}
        playsInline
        src="home-hero/or4-ceramic-home-hero-desktop-v2.mp4"
      />
    );
  } else {
    return null;
  }
});

const OR4CeramicHeroBackground = () => {
  return (
    <div className="absolute top-0 left-0 size-full bg-[#CCD1D8]">
      <StaticHero />
      <VideoHero />
    </div>
  );
};

export default OR4CeramicHeroBackground;
